import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { FlashMessageDto, FlashMessageDtoImpl } from '../dto/flashmessage/get/flashmessagedto';
import { GetPredefinedFlashMessageRequest } from '../api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesrequest';
import { GetPredefinedFlashMessageResponse, GetPredefinedFlashMessageResponseDtoImpl } from '../api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesresponse';
import { GetPredefinedFlashMessageBuilder } from '../dto/flashmessage/getpredefinedflashes/getpredefinedflashmessagebuilder';

export class GetPredefinedFlashMessageAPIProcessorImpl extends APIProcessorImpl<GetPredefinedFlashMessageRequest, GetPredefinedFlashMessageResponse>
{
    // execute(): void 
    // {
    //     let response = new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, "Get GetPredefinedFlashMessage Success");
    //       response.setFlashMessageResponseDtos(this.getFlashMessageDto());
        
    //     this.getAPISuccess(response);
    // }
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);

        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    let response = new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, "Get GetPredefinedFlashMessage Success");
                    response.setFlashMessageResponseDtos(new GetPredefinedFlashMessageBuilder(responseMapper.getResponseMap()).buildAll());
                    
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, responseMapper.getStatusMsg()));
                }
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
            this.getAPIFailure(new GetPredefinedFlashMessageResponseDtoImpl(APIFeatures.GET_PREDEFINED_FLASH_MESSAGE, responseMapper.getStatusMsg()));
    }


    getFlashMessageDto():FlashMessageDto[]
    {
        let data1 = new FlashMessageDtoImpl();
        data1.setMsisdn("");
        data1.setId("1");
        data1.setPlanName("Monthly");
        data1.setStatusMessage("Busy right now , will callback");

        let data2 = new FlashMessageDtoImpl();
        data2.setMsisdn("");
        data2.setId("2");
        data2.setPlanName("Weekly");
        data2.setStatusMessage("On vacation");

        let data3 = new FlashMessageDtoImpl();
        data3.setMsisdn("");
        data3.setId("3");
        data3.setPlanName("yearly");
        data3.setStatusMessage("In a meeting");
        return [data1, data2, data3, data3];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getpredefinedflashmessagesapiprocessor.tsx